import React, { useState, useEffect } from 'react';
import moment from 'moment';
import CTAButton from './ctaButton';
import { useRootContext } from '../context/rootContext';


const RoomTimeSelection = ({ ...props }) => {

    const {dataContext, setDataContext, scheduleContext, setScheduleContext } = useRootContext();
    const [times, setTimes] = useState([]);
    const [hasSelectedRoom, setHasSelectedRoom] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState({});
    const [isBusy, setIsBusy] = useState(false);
    //callback: onRoomUpdate

    useEffect(() => {
        if(dataContext.rooms){
            let roomsRegistered = false;

            dataContext.rooms.forEach(room => {
                if(room.registered && !room.auto_register) {
                    roomsRegistered = true;
                    setSelectedRoom(room);
                }
            });

            setHasSelectedRoom(roomsRegistered);

            if(!roomsRegistered){
                setSelectedRoom({});
            }

            const now = moment().tz('America/New_York');
            let newRooms = dataContext.rooms.filter((room)=>{
                var duration = moment.duration(now.diff(room.start));
                var seconds = duration.asSeconds();
                if(seconds < room.late_registration_buffer) return true
            });

            setTimes(newRooms);
        }
    }, [dataContext.rooms]);

    const onChooseTimeClick = () => {
        unreserveSession(selectedRoom);
    }

    const updateRooms = newRooms => {
        setDataContext({
            ...dataContext,
            rooms: newRooms
        });
    };

    const updateRoom = (i, toUpdate) => {
        let updatedRooms = [...dataContext.rooms];

        Object.keys(toUpdate).map(function (key) {
            for (let j in updatedRooms) {
                if (updatedRooms[j].unique == i) {
                    updatedRooms[j][key] = toUpdate[key];
                }
            }
        });

        updateRooms(updatedRooms);
        if(props.onRoomUpdate) props.onRoomUpdate();
    };

    const reserveSession = (session) => {
        setIsBusy(true);

        fetch(
            launchframe.ajax_url +
                '?action=register_for_room&wp_id=' +
                dataContext.current_event +
                '&room_id=' +
                session.unique,
            {
                method: 'POST'
            }
        )
            .then(res => res.json())
            .then(
                result => {
                    updateRoom(session.unique, { busy: false, registered: true });
                    setIsBusy(false);
                },

                error => {
                    setIsBusy(false);
                }
            );
    };

    const unreserveSession = (session) => {
        setIsBusy(true);

        fetch(
            launchframe.ajax_url +
                '?action=unregister_for_room&wp_id=' +
                dataContext.current_event +
                '&room_id=' +
                session.unique,
            {
                method: 'POST'
            }
        )
            .then(res => res.json())
            .then(
                result => {
                    updateRoom(session.unique, { busy: false, registered: false });
                    setIsBusy(false);
                },

                error => {
                    setIsBusy(true);
                }
            );
    };

    const timeSelectionButtons = () => {
        const buttons = times.map((time, i) => {
            if(time.auto_register) return '';
            return (
                <span key={i} className="pr-4">
                    <CTAButton
                        onButtonClick={()=>reserveSession(time)}
                        text={moment(time.start).format('h:mma') + " ET"}
                    />
                </span>
            );
        });

        return (<div><h3 className="font-bold text-2xl mr-4 mt-2 mb-4">Select Your Start Time: </h3>{buttons}</div>);
    };

    const timeSelected = (<div>
        <h3 className="font-bold text-2xl mr-4 mt-2 mb-4">Your Session: {moment(selectedRoom.start).format('h:mma')} ET</h3>
        <CTAButton
            onButtonClick={onChooseTimeClick}
            text={"Change Time"}
        />
    </div>);

    if (!dataContext.rooms || !Array.isArray(dataContext.rooms) || dataContext.rooms.length == 0) return <p>Nothing to see here</p>;
    
    return <div>{isBusy ? '' : (hasSelectedRoom ? timeSelected : timeSelectionButtons())}</div>;
};

export default RoomTimeSelection;
